import React, { Component } from 'react'

import Controls from '../common/controls'

class Screener1 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      nextClicked: false
    }
    this.next = this._next.bind(this)
  }

  _next() {
    if (this.state.nextClicked) {
      return this.props.history.go(1)
    }
    this.setState({
      nextClicked: true
    }, () => {
      return this.props.next(this.props.match.path, this.state.nextClicked)
    })
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    if (this.props.history.location.state) {
      this.setState({
        nextClicked: this.props.history.location.state
      })
    }
  }

  render() {
    return (
      <div className="screener-wrapper" id="screener_p1">
        <div className="container flex">
          <h2 className="screener-label">Newtopia is a personalized nutrition, exercise, and well-being program tailored to prevent chronic diseases.</h2>
          <h3 className="screener-label">Your personalized program includes:</h3>
          <ul className="screener-ul">
            <li>Matching you with a health coach to support you with nutrition, exercise, and well-being</li>
            <li>Optional genetic testing to find out how your genes affect your weight</li>
            <li>Smart technology and mobile app to track your progress</li>
            <li>No cost to you</li>
          </ul>
          <p className="screener-label">All of your information shall remain completely confidential and will not be shared unless we receive your prior written consent.</p>
          <Controls className="screener-button" buttonClassName="screener" nextLabel="TAKE SCREENER" next={this.next} />
        </div>
      </div>
    )
  }
}

export default Screener1